import Vue from "vue";
import { mapGetters } from "vuex";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component, Prop } from "@/decorators";
import ConfiguracaoRotuloUsuarioModel from "@/models/configuracaoRotuloUsuarioModel";
import FranquiaModel from "@/models/franquiaModel";
import UsuarioModel from "@/models/usuarioModel";
import UsuarioService from "@/services/usuarioService";
import { Getters } from "@/store/store";
import { BaseOption } from "@/types/options";

@Component({
    components: {
        comboComponent,
        gridComponent,
        fieldsetComponent,
        buttonIncluirComponent,
    },
    computed: {
        ...mapGetters(["GET_FRANQUIA_ATUAL"] as Getters),
    },
})
export default class ConfiguracaoRotuloUsuarioComponent extends Vue {
    GET_FRANQUIA_ATUAL: () => FranquiaModel;

    private usuarioService = new UsuarioService();

    @Prop({ type: Array, default: () => [] }) impressoraOptions;

    private usuarioOptions: Array<BaseOption> = [];

    get gridColumnsUsuarios(): Array<GridColumn> {
        return [
            new GridColumn("usuarioNome", this.$t("__.ts.usuario"), GridColumnType.String),
            new GridColumn("nomeImpressora", this.$t("__.ts.impressora"), GridColumnType.String),
        ];
    }

    private usuarioId: number | null = null;
    private usuarioImpressora: string | null = null;
    private usuarios: ConfiguracaoRotuloUsuarioModel[] = [];

    public usuariosEditados: boolean = false;

    set setUsuarios(usuarios: ConfiguracaoRotuloUsuarioModel[]) {
        this.usuarios = usuarios ?? [];
    }

    get getUsuarios() {
        return this.usuarios;
    }

    private async onInclusaoUsuario() {
        const isValid = await this.$validator.validateAll();
        if (!isValid) {
            return;
        }

        const usuarioComponent = this.$el.querySelector("#usuarioId") as HTMLSelectElement;

        const alreadyExists = this.usuarios.some(p => p.usuarioId == this.usuarioId);
        if (alreadyExists) {
            return;
        }

        const usuario = new ConfiguracaoRotuloUsuarioModel();
        usuario.usuarioId = this.usuarioId!;
        usuario.usuarioNome = usuarioComponent.innerText;
        usuario.nomeImpressora = this.impressoraOptions[this.usuarioImpressora!].printerName;

        this.usuarios.push(usuario);

        this.usuariosEditados = true;

        this.usuarioId = null;
        this.usuarioImpressora = null;
    }

    private onRemoveUsuario(data: ConfiguracaoRotuloUsuarioModel) {
        this.usuarios = this.usuarios.filter(p => p.usuarioId != data.usuarioId);
        this.usuariosEditados = true;
    }

    private async mounted() {
        const data = await this.usuarioService
            .listByFranquiaId(this.GET_FRANQUIA_ATUAL().id)
            .resolveWithJSON<UsuarioModel[]>();

        this.usuarioOptions = data.map(item => ({ value: item.id!, text: item.nome }));
    }
}
